const NATIVE_REMINDER_MARKER = "quick-learning-task";
export const PENDING_TASK_KEY = "ql-pending-reminder-task";

export const nativeNotificationId = task => {
  const id = Number(task.id) || 0;
  const revision = Number(task.reminder_revision) || 0;
  return ((id * 1009 + revision) % 2147483000) + 1;
};

export const schedulableTasks = (tasks, now = Date.now()) => tasks.filter(task => (
  task.reminder_enabled && !task.completed && task.due_at && new Date(task.due_at).getTime() > now
));

export const reconcileAndroidLocalReminders = async ({ tasks, plugin, now = Date.now(), soundEnabled = true }) => {
  if (!plugin) return { supported: false, scheduled: 0 };
  const permission = await plugin.checkPermissions();
  if (permission.display !== "granted") return { supported: true, permission: permission.display, scheduled: 0 };

  const desired = schedulableTasks(tasks, now);
  const desiredIds = new Set(desired.map(nativeNotificationId));
  const pending = await plugin.getPending();
  const obsolete = (pending.notifications || []).filter(item => (
    item.extra?.source === NATIVE_REMINDER_MARKER && !desiredIds.has(item.id)
  ));
  if (obsolete.length) await plugin.cancel({ notifications: obsolete.map(({ id }) => ({ id })) });
  if (desired.length) await plugin.schedule({ notifications: desired.map(task => ({
    id: nativeNotificationId(task),
    title: "Rappel Quick Learning",
    body: task.text,
    schedule: { at: new Date(task.due_at), allowWhileIdle: true },
    ...(soundEnabled ? {} : { sound: null }),
    extra: { source: NATIVE_REMINDER_MARKER, taskId: task.id, revision: task.reminder_revision },
  })) });
  return { supported: true, permission: "granted", scheduled: desired.length, cancelled: obsolete.length };
};

export const requestAndroidReminderPermission = async plugin => {
  if (!plugin) return "unsupported";
  const result = await plugin.requestPermissions();
  return result.display;
};

export const installAndroidReminderActionHandler = ({ plugin, storage, dispatch = window.dispatchEvent.bind(window) }) => {
  if (!plugin?.addListener) return null;
  return plugin.addListener("localNotificationActionPerformed", event => {
    const taskId = event?.notification?.extra?.taskId;
    if (taskId == null) return;
    storage.setItem(PENDING_TASK_KEY, String(taskId));
    dispatch(new CustomEvent("ql-open-reminder-task", { detail: { taskId: Number(taskId) } }));
  });
};
